// extracted by mini-css-extract-plugin
export default {"radio":"FlightTop_radio__IK2Zq","icon":"FlightTop_icon__7Ff3a"};